import { escapeHtml } from '../ui.js';
import { isSiteFlagTask, siteFlagTagHtml } from './site-checks-surfaces.js';

// What a task row says about where the task came from (Tasks v2 keeps these:
// "tasks raised from email, client cards, enquiries and site flags").
//
// The load, estimate, logged and timer cells that used to live here went with
// the v2 page (design_handoff_tasks_v2, "Removed").

/** EMAIL / CLIENT CARD / ENQUIRY / ASK TRACK / Site flag — the row says why it exists. */
export function sourceTag(t) {
  // A task raised from a site-check flag (hand-off §6): `source` is an OBJECT,
  // { kind: 'site-flag', … } — a "Site flag" marker, as the Triage board draws it.
  if (isSiteFlagTask(t)) return siteFlagTagHtml(t);
  if (!t || !t.source || t.source === 'manual') return '';
  if (typeof t.source !== 'string' && !t.sourceLabel) return '';   // an object source we do not know
  const label = t.sourceLabel || (t.source === 'agent' ? 'ASK TRACK' : 'SYSTEM');
  return `<span class="tk-src">${escapeHtml(label)}</span>`;
}
